/**
 * consists all the api mapping (routes)
 */
export const APIMapping = {
  GET_STATIONS: '/station',
  GET_STATION_BY_ID: '/station/:id',
  ADD_STATION: '/station',
  // UPLOAD_SIP_AND_GRADIENT: '/file_analysis',
  UPLOAD_SIP_AND_GRADIENT: '/file_analysis_async',
  GET_PROCESSING_STATUS: '/get_processing_status',
  GET_TRACKS: '/get_track_details',
  ADD_TRACK: '/add_track_details',
  ADD_STATION_SURVERY: '/add_station_survey',
  GET_PIM_IMAGE: '/get_sip_image',
  GET_PIM_PDF: '/get_gradient_pdf',
  POST_EDIT_TABLE_DATA:'/edit_station_data',
  FETCH_SURVEY_META_FILES: '/get_station_meta_files',
  GET_PIM_SIP_FILE: '/get_sip_image',
  GET_PIM_GRADIENT_FILE: '/get_gradient_file',
  GET_PIM_SIGNALLING_FILE: '/get_signal_toc_pdf',
  GET_CHILD_ROLE_USERS:'users/get-child-role-users/:current_user_role_id',
  GET_PARENT_ROLE_USERS: 'users/get-parent-role-users/:current_user_role_id',
  GET_SAME_ROLE_USERS: 'users/get-same-role-users/:current_user_role_id',
  UPDATE_STATION_STATUS:'/update_station_status',
  GET_STATION_VERSIONS:'/get_station_versions_metadata',
  GET_STATION_VERSION_FILE:'/get_station_version_file',
  GET_ALL_SELECTED_STATIONS_FILES:'/get_all_version_files',
  ADD_SIGN_TOC:'/add_sign_toc',
  ADD_SIGN_TRACK_PROFILE_DATA:'/add_sign_track_profile_data',
  ADD_SIGN_TINS_PDF:'/embed_signature_in_tins_pdf',
  ADD_SIGN_RADIO_PDF:'/embed_signature_in_radio_design',
  ADD_SIGN_RFID_TAG_DATA:'/embed_signature_in_rfid_tag',
  PLOT_OR_UPDATE_SIP: '/plot_or_update_sip_layout',
  GENERATE_COMMENTS: '/generate_comment',

  //comments
  GET_COMMENTS:'/fetch_comments',
  ADD_COMMENT:'/add_comment',
  UPDATE_COMMENT:'/update_comment',
  DELETE_COMMENT:'/delete_comment',
  ADD_REPLY:'/add_comment',

  ADD_STATION_DATA:'/update_station_master_data',

  //ZONE RULES
  GET_OEM_RULES: '/metadata/oem',
  GET_ALL_ZONES: '/metadata/zone',
  GET_ZONE_RULES_TABLE: '/rules/fetch_paginated_rule_value_applicability',
  GET_RULE_TYPES: '/rules/rule_type',
  GET_RULE_CATEGORIES: '/rules/rule_category',
  UPDATE_RULE:'/rules/rule',
  DELETE_RULE:'/rules/rule/:rule_id',
  GET_SUB_TRACKS: '/get_sub_track_details',
  ADD_SUB_TRACK: '/add_sub_track_details',
  SAVE_SUB_TRACK_DATA: '/add_station_track_subtrack_mapping_details',
  SAVE_SURVEY_DRAFT: '/save_survey_draft',
  PROCESS_SURVEY_FILE_FIRST_PASS: '/process_survey_file_first_pass',
  PROCESS_SURVEY_FILE_SECOND_PASS: '/process_survey_file_second_pass',
  GET_LAYOUT_EDIT_STATUS:'/get_station_layout_lock_status',
  UPDATE_LAYOUT_EDIT_STATUS:'/set_station_layout_edit_status',
  UPDATE_DRAFT_ACCESS_STATUS:'/update_draft_access_status',
  GENERATE_TOC_DOC: '/generate_toc_doc',
  GENERATE_TPT_DOC: '/generate_tpt_doc',
  GET_ZONE_LIST: '/get_toc_zones',
  GET_VENDOR_LIST: '/get_toc_vendors',
  GET_HEADER_TYPES: '/get_toc_types',
  CREATE_OR_UPDATE_TOC_HEADER: '/save_toc_header',
  GET_TOC_HEADER_DATA: '/get_toc_header',
  UPDATE_SIGNALLING_TOC_DATA: '/update_signal_toc_data',
  GET_TOC_CHEAT_SHEET_PDF: '/get_header_cheat_sheet',

  LOCK_STATION_LAYOUT:'/lock_station_layout',
  UNLOCK_STATION_LAYOUT:'/unlock_station_layout',
  REFRESH_STATION_LAYOUT_LOCK:'/refresh_station_layout_lock',
  GET_DB_FILE_DOWNLOAD: '/get_db_file_path',
  ON_GRADIENT_FILE_UPLOAD: '/file_analysis_async_gradient_file',
  COPY_SURVEY_DRAFT: '/clone_survey_draft',
  EXTRACT_PSR_EXCEL: '/extract_psr_excel',
  GET_ALL_TAG_DATA: '/get_rfid_tag_data_json',
  GET_STATION_IP_ADDRESS: '/get_station_ip_address',
  ZONE_VENDOR_TYPE_DELETE: '/delete_from_tocdb',
  GET_ZONES: '/get_zones',
  GET_DIVISIONS: '/get_divisions',
  GET_STATIONS_LIST: '/get_stations',
  DELETE_STATION_MASTER_DATA:'/delete_station_master_data',
  GET_TRACK_WITH_ADJUSTMENT: '/get_tracks_with_adjustments',
  SLF_CTF_FILE_UPLOAD: '/generate_slf_and_ctf_files',
  GET_SLF_CTF_FILES_DATA: '/get_slf_and_ctf_file_paths',
  GENERATE_DRAWING_SLF_FILE: '/generate_drawing_slf_file',
  GET_DRAWING_SLF_FILE: '/get_drawing_slf_file/:station_uuid',
  GAP_INTERVAL_ANALYZER: '/gap_interval_analyzer',
  GET_LAYOUT_VERSIONS: '/station-layouts/version',
  GET_LAYOUT_VERSION_DATA: '/station-layouts/undo',
  GET_LAYOUT_SUBMISSION_STATUS: '/layout_submission_status/:station_uuid',
  APPLY_ANTI_COLLISION_ON_RED_AND_GREEN_DATA: '/apply_anti_collision_on_red_and_green_data',
  APPLY_ANTI_COLLISION_PREVIEW: '/apply_anti_collision_preview',
  GENERATE_SIL0_INPUT_FILE: '/generate_sil0_input_file',

  // ===== Start Export-DWG endpoints ( from Railway-V-V-UI: PIM stepper,
  //       station, station-management, zone, division).
  ADD_ASSET: '/asset/bulk_add_assets',
  ADD_DIVISION: '/division/add_divisions',
  ADD_ZONE: '/zones/add_zone',
  BULK_DELETE_ASSETS: '/bulk_delete_assets',
  BULK_UPDATE_BBOXES: '/bulk_update_bboxes',
  CREATE_STATION_DETAILS: '/station_details/create_station_details',
  CREATE_STATION_FILES: '/station_details/create_station_files',
  CREATE_VALIDATION_COMMENT: '/file_types/create_validation_comment',
  DELETE_ADJ_STATIONS: '/station/delete_adj_stations/',
  DELETE_ASSET: '/asset/delete_asset/:asset_id/',
  DELETE_DIVISION: '/division/delete_division/:division_id/',
  DELETE_STATION: '/station/delete_station/:station_uuid/',
  DELETE_STATION_DETAILS: '/station_details/delete_station_details',
  DELETE_STATION_FILE: '/delete/',
  DELETE_VALIDATION_COMMENT: '/file_types/delete_validation_comment',
  DELETE_ZONE: '/zones/delete_zone/:zone_id/',
  FETCH_QC_REPORT: '/reports/generate',
  GET_ALL_ASSET_TYPES: '/get_asset_types',
  GET_ALL_COMMENTS_BY_VALIDATION_UUID: '/file_types/get_all_comments_by_validation_uuid',
  GET_ASSET_BY_FILTERS: '/get_assets_by_filters',
  GET_DIVISION: '/division/get_divisions_by_ids/',
  GET_DOCUMENT_TYPES: '/get_document_types',
  GET_FILE_PROCESS_STATUS: '/station_details/get_file_process_status',
  GET_MAX_DRAFT_VERSION: '/station_details/get_max_draft_version',
  GET_PROCESSED_VALIDATIONS: '/reports/generate',
  GET_SIGNALING_TOC_TEMPLATES: '/toc/templates/type/signaling_toc',
  GET_STATION: '/station/get_stations_by_ids/',
  GET_STATION_DETAILS: '/station_details/get_all_station_details/',
  GET_STATION_FILES: '/station_details/fetch_station_document_files',
  GET_STREAM_FILE: '/stream_file',
  GET_VNV_STREAM_FILE: '/stream_file/stream_file',
  GET_SURVEY_FILES: '/survey_file/get_survey_files/:station_uuid',
  GET_TOC_DATA: '/toc/toc_data/:toc_type/:station_details_id',
  GET_TOC_TEMPLATES: '/toc/templates/type/table_of_control',
  GET_VALIDATION_RULES: '/file_types/get_validation_rules',
  GET_VALIDATION_SUMMARY: '/file_types/get_validation_summary',
  GET_ZONE: '/zones/get_zones_by_id/',
  PROCESS_SIGNALING_TOC_FILE: '/toc/process_toc_file',
  PROCESS_TOC_FILE: '/toc/process_toc_file',
  REASSOCIATE_ASSETS: '/track/reassociate_assets/',
  SAVE_TOC_DATA: '/toc/toc_data/update/',
  UPDATE_ASSET: '/bulk_update_assets',
  UPDATE_DIVISION: '/division/update_division',
  UPDATE_FILE_PROCESSED_STATUS: '/station_details/update_file_processed_status',
  UPDATE_STATION: '/station/update_station',
  UPDATE_STATION_DETAILS: '/station_details/update_station_details/',
  UPDATE_STATION_FILES: '/station_details/update_station_files/',
  UPDATE_VALIDATION_COMMENT: '/file_types/update_validation_comment',
  UPDATE_VALIDATION_RULES: '/file_types/update_validation_rules',
  UPDATE_ZONE: '/zones/update_zone/',
  VERIFY_VALIDATE: '/validation/verify_validate',
  UPLOAD_CAD_FILE: '/upload/',
  GENERATE_RFID_LAYOUT: '/generate_rfid_layout',
  GET_TRACKS_BY_STATION: '/get_tracks_by_station',
  // ===== END Export-DWG endpoints =====
}
